export async function fetchJson<T>(url: string, timeoutMs = 8_000): Promise<T> {
  const controller = new AbortController();
  const timeout = globalThis.setTimeout(() => controller.abort(), timeoutMs);
  try {
    const response = await fetch(url, {
      signal: controller.signal,
      headers: { Accept: 'application/json' },
      cache: 'no-store',
    });
    if (!response.ok) throw new Error(`HTTP ${response.status} for ${url}`);
    return (await response.json()) as T;
  } catch (error) {
    if (error instanceof DOMException && error.name === 'AbortError') throw new Error(`Timeout after ${timeoutMs}ms for ${url}`);
    throw error;
  } finally {
    globalThis.clearTimeout(timeout);
  }
}

export async function fetchFirstJson<T>(urls: string[], timeoutMs = 6_000): Promise<T> {
  const errors: string[] = [];
  for (const url of urls) {
    try {
      return await fetchJson<T>(url, timeoutMs);
    } catch (error) {
      errors.push(error instanceof Error ? error.message : `Request failed for ${url}`);
    }
  }
  throw new Error(errors.join(' | '));
}
